export const SEARCH_MODAL_TRANSLATION_KEYS = [
  "casino.search_games",
  "casino.clear_search",
  "casino.search.surprise_me",
  "casino.search.close",
  "casino.search.all",
  "casino.search.slots",
  "casino.search.live-casino",
  "casino.search.originals",
  "casino.search.new_results",
  "casino.search.top_search_games",
  "general.search.results_none",
  "casino.search.not_found_subtitle",
  "casino.search.load_more",
] as const;
